import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CategoryAuditlogComponent } from './category-auditlog/category-auditlog.component';
import { GridApi } from 'ag-grid-community';
import { Subject, SubscriptionLike } from 'rxjs';
import { AuditlogServiceService } from 'src/app/services/um/auditlog-service.service';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-super-admin-audit-log',
  templateUrl: './super-admin-audit-log.component.html',
  styleUrls: ['./super-admin-audit-log.component.scss']
})
export class SuperAdminAuditLogComponent implements OnInit {


  subSearchRecords: SubscriptionLike;
  operations;
  tempoperation;
  selectedRow;
  IsAdvanceSearch: boolean = true;
  gridApi: GridApi;
  rowData: any = [];
  columnDefs: any;
  SupderAdminAuditForm: UntypedFormGroup;
  action: Subject<any> = new Subject();
  log_data: any;
  grayout: boolean = true;
  Categorylst: any[] = [];

  myDate = new Date();
  yesterday = new Date(this.myDate.setDate(new Date().getDate() + 1));
  year = this.yesterday.getFullYear();
  moth = this.yesterday.getMonth() + 1;
  Day = this.yesterday.getDate();
  

  minDate:Date = new Date(); 
  maxDate:Date = new Date(); 
  currentDate : Date = new Date(); 
  constructor(public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    public ApiService: AuditlogServiceService,
    private commonservice: CommonService,
  ) { }

  ngOnInit(): void {
    this.Categorylst.push({
      label: "Select",
      value: ""
    })
    this.Categorylst.push({
      label: "Organizations",
      value: "Organization"
    })
    this.Categorylst.push({
      label: "Users",
      value: "User Management"
    })
    this.Categorylst.push({
      label: "Authentications",
      value: "Authentication"
    })
    this.IsAdvanceSearch = true;
    this.grayout = true;
    this.gridHeaderandActionSettings();
    this.SupderAdminFormControls()
    this.SupderAdminAuditForm.controls["Name"].disable();
    this.SupderAdminAuditForm.get("Category").patchValue("");
  }

  toggleCase() {
    this.IsAdvanceSearch = !this.IsAdvanceSearch;
  }

  SupderAdminFormControls() {
    this.SupderAdminAuditForm = new UntypedFormGroup({
      Category: new UntypedFormControl(""),
      Name: new UntypedFormControl(""),
      StartDate: new UntypedFormControl(null),
      EndDate: new UntypedFormControl(null),
      UserName: new UntypedFormControl(""),
      VersionID: new UntypedFormControl(""),
      RelatedPKID: new UntypedFormControl(""),
    })
  }

  gridHeaderandActionSettings() {
    this.columnDefs = [
      { headerName: "Revision", headerTooltip: "Revision", field: 'RevisionNum', sortable: false, tooltipField: "RevisionNum" },
      { headerName: "Name", headerTooltip: "Name", field: 'category', sortable: false, tooltipField: "category" },
      { headerName: "Change Description", headerTooltip: "Change Description", field: 'ChangeDescription', sortable: false, tooltipField: "ChangeDescription" },
      { headerName: "Username", headerTooltip: "Username", field: 'UserName', sortable: false, tooltipField: "UserName" },
      { headerName: "Changed on Date and Time", headerTooltip: "Changed on Date and Time", field: 'CreatedDate', sortable: false, tooltipField: "CreatedDate" }
    ];
    this.tempoperation = [];
    this.tempoperation.push({
      "name": "View",
      "id": "View"
    });
    this.operations = this.tempoperation.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  OnCategoryChange(event) {
    if (event == "") {
      this.grayout = true;
      this.SupderAdminAuditForm.controls["Name"].disable();

    }
    else {
      this.grayout = false;
      this.SupderAdminAuditForm.controls["Name"].enable();
    }
  }

  Clear() {
    this.SupderAdminAuditForm.patchValue({
      Category: "",
      Name: "",
      StartDate: null,
      EndDate: null
    });
    this.SupderAdminAuditForm.controls["Name"].disable();
    this.SupderAdminAuditForm.get("Category").patchValue("");
    this.rowData = [];
    this.grayout = true;
    this.maxDate = new Date();
  }


 

  startDateSelect(event) {
 
    this.minDate = new Date(event);
  }
  endDateSelect(event) {

    this.maxDate = new Date(event);
  }

  Search() {
    if (this.validateForm()) {

      this.subSearchRecords = this.ApiService.searchRecords(this.SupderAdminAuditForm.getRawValue()).subscribe(result => {
        if (result != null) {
          this.rowData = result;
        } else {
          this.rowData = [];
        }
      });
    }
  }

  validateForm() {
    let isValid = true;
    var err: any = "";

    if ((this.SupderAdminAuditForm.get('Category')?.value == null || this.SupderAdminAuditForm.get('Category')?.value == "") && 
    (this.SupderAdminAuditForm.get('Name')?.value == null || this.SupderAdminAuditForm.get('Name')?.value == "") &&
    (this.SupderAdminAuditForm.get('StartDate')?.value == null || this.SupderAdminAuditForm.get('StartDate')?.value == "") && 
    this.SupderAdminAuditForm.get('EndDate')?.value == null || this.SupderAdminAuditForm.get('EndDate')?.value == "") {
      err = err + "Provide at least one criteria to perform search </br>";
    }
    if ((this.SupderAdminAuditForm.get('StartDate')?.value != null && this.SupderAdminAuditForm.get('StartDate')?.value != "") && 
    (this.SupderAdminAuditForm.get('EndDate')?.value != null && this.SupderAdminAuditForm.get('EndDate')?.value != "") &&
     (this.SupderAdminAuditForm.get('Category')?.value == null || this.SupderAdminAuditForm.get('Category')?.value == "")) {
       err = err + "Please select Category </br>";
    }
    else if ((this.SupderAdminAuditForm.get('Category')?.value == null || this.SupderAdminAuditForm.get('Category')?.value == "") &&
     (this.SupderAdminAuditForm.get('StartDate')?.value != null || this.SupderAdminAuditForm.get('EndDate')?.value != null)) {
    err = err +"Please select Category </br>";
    }
    if ((this.SupderAdminAuditForm.get('EndDate')?.value == null || this.SupderAdminAuditForm.get('EndDate')?.value == "")) {
      if ((this.SupderAdminAuditForm.get('StartDate')?.value != null && this.SupderAdminAuditForm.get('StartDate')?.value != ""))
          err = err +"Please select end date </br>";
    }
    if ((this.SupderAdminAuditForm.get('StartDate')?.value == null || this.SupderAdminAuditForm.get('StartDate')?.value == "")) {
      if ((this.SupderAdminAuditForm.get('EndDate')?.value != null && this.SupderAdminAuditForm.get('EndDate')?.value != ""))
        err = err +"Please select start date </br>";
    }
   
    if (err && err.length > 0) {
      this.commonservice.ValidationBanner(err);
      isValid = false;
    }
    return isValid;
  }


  View(RecordData: any) {
      
    var VersionID = RecordData['VersionID'];
    var RelatedPKID = RecordData['RelatedPKID'];
    var RevisionNo = RecordData['RevisionNum'];
    var heading = this['self'].SupderAdminAuditForm.controls["Category"].value;
    var CategoryName = this['self'].SupderAdminAuditForm.controls["Category"].value;
    if(CategoryName=="User Management")
      {
        CategoryName="Users";
      }
    this.log_data = RecordData;
    let modalRef1 = this['self'].modalService.open(CategoryAuditlogComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true,
    });
    modalRef1.componentInstance.Content={
      heading: heading,
      content: {
        RevisionNo: RevisionNo, VersionID: VersionID, RelatedPKID: RelatedPKID,
        category_name: CategoryName, log_data: this.log_data
      }
    }

  }

  onRowDoubleClicked(RecordData: any) {
      
    var VersionID = RecordData.data['VersionID'];
    var RelatedPKID = RecordData.data['RelatedPKID'];
    var RevisionNo = RecordData.data['RevisionNum'];
  var heading = this.SupderAdminAuditForm.controls["Category"].value;
  var CategoryName = this.SupderAdminAuditForm.controls["Category"].value;
  if(CategoryName=="User Management")
    {
      CategoryName="Users";
    }
    this.log_data = RecordData.data;
  let modalRef1 = this.modalService.open(CategoryAuditlogComponent, {
    backdrop: false,
    keyboard: false,
    windowClass: 'modal-xl right modal-right',
    animation: true
  });
  modalRef1.componentInstance.Content={
    heading: heading,
    content: {
      RevisionNo: RevisionNo, VersionID: VersionID, RelatedPKID: RelatedPKID,
      category_name: CategoryName, log_data: this.log_data
    }
  }
  }

 
}
